import { BrandLogo } from '@/components/common/BrandLogo';
import { AssistantLauncher } from '@/components/assistant/AssistantLauncher';
import { NotificationBell } from '@/components/common/NotificationBell';

export function PractitionerMobileHeader() {
  return (
    <header className="lg:hidden bg-zoowhite border-b border-zooborder px-5 py-3 flex items-center justify-between gap-3">
      <div className="min-w-0 flex-1">
        <BrandLogo className="h-8 max-w-full w-auto object-contain" />
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <AssistantLauncher isCompact={true} />
        <NotificationBell />
      </div>
    </header>
  );
}
